"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useSendNavigationSignal = require("./useSendNavigationSignal");
Object.keys(_useSendNavigationSignal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useSendNavigationSignal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useSendNavigationSignal[key];
    }
  });
});
var _useAddToBasketAnalytics = require("./useAddToBasketAnalytics");
Object.keys(_useAddToBasketAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useAddToBasketAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useAddToBasketAnalytics[key];
    }
  });
});
